import * as React from 'react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { cn } from '~/client/src/shared/utils/cn'

const MapControlButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, children, ...rest }, ref) => (
  <Button
    ref={ref}
    type="button"
    variant="ghost"
    size="icon"
    // Lets the map attribution inset itself only where a control is actually rendered.
    data-map-control=""
    className={cn(
      'tw:size-10 tw:rounded-full tw:bg-card tw:text-muted-foreground tw:border-border tw:shadow-[0px_1px_2px_rgba(0,0,0,0.3),0px_2px_6px_rgba(0,0,0,0.15)]',
      className,
    )}
    {...rest}
  >
    {children}
  </Button>
))

export default MapControlButton
